// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/nucleo-icons.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/nucleo-icons.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/nucleo-icons.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/nucleo-icons.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/nucleo-icons.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*--------------------------------

hermes-dashboard-icons Web Font - built using nucleoapp.com
License - nucleoapp.com/license/

-------------------------------- */
@font-face {
  font-family: "NucleoIcons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("embedded-opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("svg");
  font-weight: normal;
  font-style: normal;
}

/*------------------------
    base class definition
-------------------------*/
.ni {
  display: inline-block;
  font: normal normal normal 14px/1 NucleoIcons;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/*------------------------
  change icon size
-------------------------*/
.ni-lg {
  font-size: 1.33333333em;
  line-height: 0.75em;
  vertical-align: -15%;
}

.ni-2x {
  font-size: 2em;
}

.ni-3x {
  font-size: 3em;
}

.ni-4x {
  font-size: 4em;
}

.ni-5x {
  font-size: 5em;
}

/*----------------------------------
  add a square/circle background
-----------------------------------*/
.ni.square,
.ni.circle {
  padding: 0.33333333em;
  vertical-align: -16%;
  background-color: #eee;
}

.ni.circle {
  border-radius: 50%;
}

/*------------------------
  list icons
-------------------------*/
.ni-ul {
  padding-left: 0;
  margin-left: 2.14285714em;
  list-style-type: none;
}

.ni-ul > li {
  position: relative;
}

.ni-ul > li > .ni {
  position: absolute;
  left: -1.57142857em;
  top: 0.14285714em;
  text-align: center;
}

.ni-ul > li > .ni.lg {
  top: 0;
  left: -1.35714286em;
}

.ni-ul > li > .ni.circle,
.ni-ul > li > .ni.square {
  top: -0.19047619em;
  left: -1.9047619em;
}

/*------------------------
  spinning icons
-------------------------*/
.ni.spin {
  animation: nc-spin 2s infinite linear;
}

@keyframes nc-spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/*------------------------
  rotated/flipped icons
-------------------------*/
.ni.rotate-90 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
  transform: rotate(90deg);
}

.ni.rotate-180 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: rotate(180deg);
}

.ni.rotate-270 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
  transform: rotate(270deg);
}

.ni.flip-y {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0);
  transform: scale(-1, 1);
}

.ni.flip-x {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: scale(1, -1);
}

/*------------------------
    font icons
-------------------------*/

.ni-active-40::before {
  content: "\\ea02";
}

.ni-air-baloon::before {
  content: "\\ea03";
}

.ni-album-2::before {
  content: "\\ea04";
}

.ni-align-center::before {
  content: "\\ea05";
}

.ni-align-left-2::before {
  content: "\\ea06";
}

.ni-ambulance::before {
  content: "\\ea07";
}

.ni-app::before {
  content: "\\ea08";
}

.ni-archive-2::before {
  content: "\\ea09";
}

.ni-atom::before {
  content: "\\ea0a";
}

.ni-badge::before {
  content: "\\ea0b";
}

.ni-bag-17::before {
  content: "\\ea0c";
}

.ni-basket::before {
  content: "\\ea0d";
}

.ni-bell-55::before {
  content: "\\ea0e";
}

.ni-bold-down::before {
  content: "\\ea0f";
}

.ni-bold-left::before {
  content: "\\ea10";
}

.ni-bold-right::before {
  content: "\\ea11";
}

.ni-bold-up::before {
  content: "\\ea12";
}

.ni-bold::before {
  content: "\\ea13";
}

.ni-book-bookmark::before {
  content: "\\ea14";
}

.ni-books::before {
  content: "\\ea15";
}

.ni-box-2::before {
  content: "\\ea16";
}

.ni-briefcase-24::before {
  content: "\\ea17";
}

.ni-building::before {
  content: "\\ea18";
}

.ni-bulb-61::before {
  content: "\\ea19";
}

.ni-bullet-list-67::before {
  content: "\\ea1a";
}

.ni-bus-front-12::before {
  content: "\\ea1b";
}

.ni-button-pause::before {
  content: "\\ea1c";
}

.ni-button-play::before {
  content: "\\ea1d";
}

.ni-button-power::before {
  content: "\\ea1e";
}

.ni-calendar-grid-58::before {
  content: "\\ea1f";
}

.ni-camera-compact::before {
  content: "\\ea20";
}

.ni-caps-small::before {
  content: "\\ea21";
}

.ni-cart::before {
  content: "\\ea22";
}

.ni-chart-bar-32::before {
  content: "\\ea23";
}

.ni-chart-pie-35::before {
  content: "\\ea24";
}

.ni-chat-round::before {
  content: "\\ea25";
}

.ni-check-bold::before {
  content: "\\ea26";
}

.ni-circle-08::before {
  content: "\\ea27";
}

.ni-cloud-download-95::before {
  content: "\\ea28";
}

.ni-cloud-upload-96::before {
  content: "\\ea29";
}

.ni-compass-04::before {
  content: "\\ea2a";
}

.ni-controller::before {
  content: "\\ea2b";
}

.ni-credit-card::before {
  content: "\\ea2c";
}

.ni-curved-next::before {
  content: "\\ea2d";
}

.ni-delivery-fast::before {
  content: "\\ea2e";
}

.ni-diamond::before {
  content: "\\ea2f";
}

.ni-email-83::before {
  content: "\\ea30";
}

.ni-fat-add::before {
  content: "\\ea31";
}

.ni-fat-delete::before {
  content: "\\ea32";
}

.ni-fat-remove::before {
  content: "\\ea33";
}

.ni-favourite-28::before {
  content: "\\ea34";
}

.ni-folder-17::before {
  content: "\\ea35";
}

.ni-glasses-2::before {
  content: "\\ea36";
}

.ni-hat-3::before {
  content: "\\ea37";
}

.ni-headphones::before {
  content: "\\ea38";
}

.ni-html5::before {
  content: "\\ea39";
}

.ni-istanbul::before {
  content: "\\ea3a";
}

.ni-key-25::before {
  content: "\\ea3b";
}

.ni-laptop::before {
  content: "\\ea3c";
}

.ni-like-2::before {
  content: "\\ea3d";
}

.ni-lock-circle-open::before {
  content: "\\ea3e";
}

.ni-map-big::before {
  content: "\\ea3f";
}

.ni-mobile-button::before {
  content: "\\ea40";
}

.ni-money-coins::before {
  content: "\\ea41";
}

.ni-note-03::before {
  content: "\\ea42";
}

.ni-notification-70::before {
  content: "\\ea43";
}

.ni-palette::before {
  content: "\\ea44";
}

.ni-paper-diploma::before {
  content: "\\ea45";
}

.ni-pin-3::before {
  content: "\\ea46";
}

.ni-planet::before {
  content: "\\ea47";
}

.ni-ruler-pencil::before {
  content: "\\ea48";
}

.ni-satisfied::before {
  content: "\\ea49";
}

.ni-scissors::before {
  content: "\\ea4a";
}

.ni-send::before {
  content: "\\ea4b";
}

.ni-settings-gear-65::before {
  content: "\\ea4c";
}

.ni-settings::before {
  content: "\\ea4d";
}

.ni-single-02::before {
  content: "\\ea4e";
}

.ni-single-copy-04::before {
  content: "\\ea4f";
}

.ni-sound-wave::before {
  content: "\\ea50";
}

.ni-spaceship::before {
  content: "\\ea51";
}

.ni-square-pin::before {
  content: "\\ea52";
}

.ni-support-16::before {
  content: "\\ea53";
}

.ni-tablet-button::before {
  content: "\\ea54";
}

.ni-tag::before {
  content: "\\ea55";
}

.ni-tie-bow::before {
  content: "\\ea56";
}

.ni-time-alarm::before {
  content: "\\ea57";
}

.ni-trophy::before {
  content: "\\ea58";
}

.ni-tv-2::before {
  content: "\\ea59";
}

.ni-umbrella-13::before {
  content: "\\ea5a";
}

.ni-user-run::before {
  content: "\\ea5b";
}

.ni-vector::before {
  content: "\\ea5c";
}

.ni-watch-time::before {
  content: "\\ea5d";
}

.ni-world::before {
  content: "\\ea5e";
}

.ni-zoom-split-in::before {
  content: "\\ea5f";
}

.ni-collection::before {
  content: "\\ea60";
}

.ni-image::before {
  content: "\\ea61";
}

.ni-shop::before {
  content: "\\ea62";
}

.ni-ungroup::before {
  content: "\\ea63";
}

.ni-world-2::before {
  content: "\\ea64";
}

.ni-ui-04::before {
  content: "\\ea65";
}

/* all icon font classes list here */
`, "",{"version":3,"sources":["webpack://./src/assets/plugins/nucleo/css/nucleo.css"],"names":[],"mappings":"AAAA;;;;;kCAKkC;AAClC;EACE,0BAA0B;EAC1B,4CAAqC;EACrC;;;;;yDAKgD;EAChD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;0BAE0B;AAC1B;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;0BAE0B;AAC1B;EACE,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;oCAEoC;AACpC;;EAEE,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;0BAE0B;AAC1B;EACE,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,MAAM;EACN,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;0BAE0B;AAC1B;EAGE,qCAAqC;AACvC;;AAsBA;EACE;IAKE,uBAAuB;EACzB;;EAEA;IAKE,yBAAyB;EAC3B;AACF;;AAEA;;0BAE0B;AAC1B;EACE,gEAAgE;EAKhE,wBAAwB;AAC1B;;AAEA;EACE,gEAAgE;EAKhE,yBAAyB;AAC3B;;AAEA;EACE,gEAAgE;EAKhE,yBAAyB;AAC3B;;AAEA;EACE,gEAAgE;EAKhE,uBAAuB;AACzB;;AAEA;EACE,gEAAgE;EAKhE,uBAAuB;AACzB;;AAEA;;0BAE0B;;AAE1B;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oCAAoC","sourcesContent":["/*--------------------------------\n\nhermes-dashboard-icons Web Font - built using nucleoapp.com\nLicense - nucleoapp.com/license/\n\n-------------------------------- */\n@font-face {\n  font-family: \"NucleoIcons\";\n  src: url(\"../fonts/nucleo-icons.eot\");\n  src:\n    url(\"../fonts/nucleo-icons.eot\") format(\"embedded-opentype\"),\n    url(\"../fonts/nucleo-icons.woff2\") format(\"woff2\"),\n    url(\"../fonts/nucleo-icons.woff\") format(\"woff\"),\n    url(\"../fonts/nucleo-icons.ttf\") format(\"truetype\"),\n    url(\"../fonts/nucleo-icons.svg\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n/*------------------------\n    base class definition\n-------------------------*/\n.ni {\n  display: inline-block;\n  font: normal normal normal 14px/1 NucleoIcons;\n  font-size: inherit;\n  text-rendering: auto;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/*------------------------\n  change icon size\n-------------------------*/\n.ni-lg {\n  font-size: 1.33333333em;\n  line-height: 0.75em;\n  vertical-align: -15%;\n}\n\n.ni-2x {\n  font-size: 2em;\n}\n\n.ni-3x {\n  font-size: 3em;\n}\n\n.ni-4x {\n  font-size: 4em;\n}\n\n.ni-5x {\n  font-size: 5em;\n}\n\n/*----------------------------------\n  add a square/circle background\n-----------------------------------*/\n.ni.square,\n.ni.circle {\n  padding: 0.33333333em;\n  vertical-align: -16%;\n  background-color: #eee;\n}\n\n.ni.circle {\n  border-radius: 50%;\n}\n\n/*------------------------\n  list icons\n-------------------------*/\n.ni-ul {\n  padding-left: 0;\n  margin-left: 2.14285714em;\n  list-style-type: none;\n}\n\n.ni-ul > li {\n  position: relative;\n}\n\n.ni-ul > li > .ni {\n  position: absolute;\n  left: -1.57142857em;\n  top: 0.14285714em;\n  text-align: center;\n}\n\n.ni-ul > li > .ni.lg {\n  top: 0;\n  left: -1.35714286em;\n}\n\n.ni-ul > li > .ni.circle,\n.ni-ul > li > .ni.square {\n  top: -0.19047619em;\n  left: -1.9047619em;\n}\n\n/*------------------------\n  spinning icons\n-------------------------*/\n.ni.spin {\n  -webkit-animation: nc-spin 2s infinite linear;\n  -moz-animation: nc-spin 2s infinite linear;\n  animation: nc-spin 2s infinite linear;\n}\n\n@-webkit-keyframes nc-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n  }\n\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n\n@-moz-keyframes nc-spin {\n  0% {\n    -moz-transform: rotate(0deg);\n  }\n\n  100% {\n    -moz-transform: rotate(360deg);\n  }\n}\n\n@keyframes nc-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n/*------------------------\n  rotated/flipped icons\n-------------------------*/\n.ni.rotate-90 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);\n  -webkit-transform: rotate(90deg);\n  -moz-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  -o-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n\n.ni.rotate-180 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n  -webkit-transform: rotate(180deg);\n  -moz-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  -o-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n\n.ni.rotate-270 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);\n  -webkit-transform: rotate(270deg);\n  -moz-transform: rotate(270deg);\n  -ms-transform: rotate(270deg);\n  -o-transform: rotate(270deg);\n  transform: rotate(270deg);\n}\n\n.ni.flip-y {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0);\n  -webkit-transform: scale(-1, 1);\n  -moz-transform: scale(-1, 1);\n  -ms-transform: scale(-1, 1);\n  -o-transform: scale(-1, 1);\n  transform: scale(-1, 1);\n}\n\n.ni.flip-x {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n  -webkit-transform: scale(1, -1);\n  -moz-transform: scale(1, -1);\n  -ms-transform: scale(1, -1);\n  -o-transform: scale(1, -1);\n  transform: scale(1, -1);\n}\n\n/*------------------------\n    font icons\n-------------------------*/\n\n.ni-active-40::before {\n  content: \"\\ea02\";\n}\n\n.ni-air-baloon::before {\n  content: \"\\ea03\";\n}\n\n.ni-album-2::before {\n  content: \"\\ea04\";\n}\n\n.ni-align-center::before {\n  content: \"\\ea05\";\n}\n\n.ni-align-left-2::before {\n  content: \"\\ea06\";\n}\n\n.ni-ambulance::before {\n  content: \"\\ea07\";\n}\n\n.ni-app::before {\n  content: \"\\ea08\";\n}\n\n.ni-archive-2::before {\n  content: \"\\ea09\";\n}\n\n.ni-atom::before {\n  content: \"\\ea0a\";\n}\n\n.ni-badge::before {\n  content: \"\\ea0b\";\n}\n\n.ni-bag-17::before {\n  content: \"\\ea0c\";\n}\n\n.ni-basket::before {\n  content: \"\\ea0d\";\n}\n\n.ni-bell-55::before {\n  content: \"\\ea0e\";\n}\n\n.ni-bold-down::before {\n  content: \"\\ea0f\";\n}\n\n.ni-bold-left::before {\n  content: \"\\ea10\";\n}\n\n.ni-bold-right::before {\n  content: \"\\ea11\";\n}\n\n.ni-bold-up::before {\n  content: \"\\ea12\";\n}\n\n.ni-bold::before {\n  content: \"\\ea13\";\n}\n\n.ni-book-bookmark::before {\n  content: \"\\ea14\";\n}\n\n.ni-books::before {\n  content: \"\\ea15\";\n}\n\n.ni-box-2::before {\n  content: \"\\ea16\";\n}\n\n.ni-briefcase-24::before {\n  content: \"\\ea17\";\n}\n\n.ni-building::before {\n  content: \"\\ea18\";\n}\n\n.ni-bulb-61::before {\n  content: \"\\ea19\";\n}\n\n.ni-bullet-list-67::before {\n  content: \"\\ea1a\";\n}\n\n.ni-bus-front-12::before {\n  content: \"\\ea1b\";\n}\n\n.ni-button-pause::before {\n  content: \"\\ea1c\";\n}\n\n.ni-button-play::before {\n  content: \"\\ea1d\";\n}\n\n.ni-button-power::before {\n  content: \"\\ea1e\";\n}\n\n.ni-calendar-grid-58::before {\n  content: \"\\ea1f\";\n}\n\n.ni-camera-compact::before {\n  content: \"\\ea20\";\n}\n\n.ni-caps-small::before {\n  content: \"\\ea21\";\n}\n\n.ni-cart::before {\n  content: \"\\ea22\";\n}\n\n.ni-chart-bar-32::before {\n  content: \"\\ea23\";\n}\n\n.ni-chart-pie-35::before {\n  content: \"\\ea24\";\n}\n\n.ni-chat-round::before {\n  content: \"\\ea25\";\n}\n\n.ni-check-bold::before {\n  content: \"\\ea26\";\n}\n\n.ni-circle-08::before {\n  content: \"\\ea27\";\n}\n\n.ni-cloud-download-95::before {\n  content: \"\\ea28\";\n}\n\n.ni-cloud-upload-96::before {\n  content: \"\\ea29\";\n}\n\n.ni-compass-04::before {\n  content: \"\\ea2a\";\n}\n\n.ni-controller::before {\n  content: \"\\ea2b\";\n}\n\n.ni-credit-card::before {\n  content: \"\\ea2c\";\n}\n\n.ni-curved-next::before {\n  content: \"\\ea2d\";\n}\n\n.ni-delivery-fast::before {\n  content: \"\\ea2e\";\n}\n\n.ni-diamond::before {\n  content: \"\\ea2f\";\n}\n\n.ni-email-83::before {\n  content: \"\\ea30\";\n}\n\n.ni-fat-add::before {\n  content: \"\\ea31\";\n}\n\n.ni-fat-delete::before {\n  content: \"\\ea32\";\n}\n\n.ni-fat-remove::before {\n  content: \"\\ea33\";\n}\n\n.ni-favourite-28::before {\n  content: \"\\ea34\";\n}\n\n.ni-folder-17::before {\n  content: \"\\ea35\";\n}\n\n.ni-glasses-2::before {\n  content: \"\\ea36\";\n}\n\n.ni-hat-3::before {\n  content: \"\\ea37\";\n}\n\n.ni-headphones::before {\n  content: \"\\ea38\";\n}\n\n.ni-html5::before {\n  content: \"\\ea39\";\n}\n\n.ni-istanbul::before {\n  content: \"\\ea3a\";\n}\n\n.ni-key-25::before {\n  content: \"\\ea3b\";\n}\n\n.ni-laptop::before {\n  content: \"\\ea3c\";\n}\n\n.ni-like-2::before {\n  content: \"\\ea3d\";\n}\n\n.ni-lock-circle-open::before {\n  content: \"\\ea3e\";\n}\n\n.ni-map-big::before {\n  content: \"\\ea3f\";\n}\n\n.ni-mobile-button::before {\n  content: \"\\ea40\";\n}\n\n.ni-money-coins::before {\n  content: \"\\ea41\";\n}\n\n.ni-note-03::before {\n  content: \"\\ea42\";\n}\n\n.ni-notification-70::before {\n  content: \"\\ea43\";\n}\n\n.ni-palette::before {\n  content: \"\\ea44\";\n}\n\n.ni-paper-diploma::before {\n  content: \"\\ea45\";\n}\n\n.ni-pin-3::before {\n  content: \"\\ea46\";\n}\n\n.ni-planet::before {\n  content: \"\\ea47\";\n}\n\n.ni-ruler-pencil::before {\n  content: \"\\ea48\";\n}\n\n.ni-satisfied::before {\n  content: \"\\ea49\";\n}\n\n.ni-scissors::before {\n  content: \"\\ea4a\";\n}\n\n.ni-send::before {\n  content: \"\\ea4b\";\n}\n\n.ni-settings-gear-65::before {\n  content: \"\\ea4c\";\n}\n\n.ni-settings::before {\n  content: \"\\ea4d\";\n}\n\n.ni-single-02::before {\n  content: \"\\ea4e\";\n}\n\n.ni-single-copy-04::before {\n  content: \"\\ea4f\";\n}\n\n.ni-sound-wave::before {\n  content: \"\\ea50\";\n}\n\n.ni-spaceship::before {\n  content: \"\\ea51\";\n}\n\n.ni-square-pin::before {\n  content: \"\\ea52\";\n}\n\n.ni-support-16::before {\n  content: \"\\ea53\";\n}\n\n.ni-tablet-button::before {\n  content: \"\\ea54\";\n}\n\n.ni-tag::before {\n  content: \"\\ea55\";\n}\n\n.ni-tie-bow::before {\n  content: \"\\ea56\";\n}\n\n.ni-time-alarm::before {\n  content: \"\\ea57\";\n}\n\n.ni-trophy::before {\n  content: \"\\ea58\";\n}\n\n.ni-tv-2::before {\n  content: \"\\ea59\";\n}\n\n.ni-umbrella-13::before {\n  content: \"\\ea5a\";\n}\n\n.ni-user-run::before {\n  content: \"\\ea5b\";\n}\n\n.ni-vector::before {\n  content: \"\\ea5c\";\n}\n\n.ni-watch-time::before {\n  content: \"\\ea5d\";\n}\n\n.ni-world::before {\n  content: \"\\ea5e\";\n}\n\n.ni-zoom-split-in::before {\n  content: \"\\ea5f\";\n}\n\n.ni-collection::before {\n  content: \"\\ea60\";\n}\n\n.ni-image::before {\n  content: \"\\ea61\";\n}\n\n.ni-shop::before {\n  content: \"\\ea62\";\n}\n\n.ni-ungroup::before {\n  content: \"\\ea63\";\n}\n\n.ni-world-2::before {\n  content: \"\\ea64\";\n}\n\n.ni-ui-04::before {\n  content: \"\\ea65\";\n}\n\n/* all icon font classes list here */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
